// Styles
import CRNTCashStockContainer from "./CRNTCashStock.styles";
import ReportsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import AlertsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/AlertsTab/AlertsTab";
import ChangeLogTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ChangeLogTab/ChangeLogTab";
import Tabs from "../../../../components/Common/Tabs/Tabs";

interface CRNTCashStockProps {}

const checkName = "cr_nt_cash_stock";

const CRNTCashStock = ({}: CRNTCashStockProps) => {
    return (
        <CRNTCashStockContainer>
            <p className={"sectionTitle"}>CR VS NT CASH + STOCK</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="e0df7354-ee9a-4a43-a0fa-dd0cbeb3c748" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128" />,
                    },
                    {
                        value: "alerts",
                        title: "ALERTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <AlertsTab checkName={checkName} />,
                    },
                    {
                        value: "change_log",
                        title: "CHANGE LOG",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ChangeLogTab checkName={checkName} />,
                    },
                ]}
            />
        </CRNTCashStockContainer>
    );
};

export default CRNTCashStock;
